export const trans_13_1=[
  {
    id:1,
    english:'I have got some recommendations',
    vietnamese:'Tôi vừa nhận được vài lời gợi ý',
    user_message:''
  },
  {
    id:2,
    english:'Dear darling! Can you help mama?',
    vietnamese:'Con yêu! Còn có thể giúp mẹ không?',
    user_message:''
  },
  {
    id:3,
    english:'Today, we had one difficult problem and nobody could fix it',
    vietnamese:'Hôm nay, chúng tôi gặp một vấn đề khó và không ai có thể giải được',
    user_message:''
  },
  {
    id:4,
    english:'Can you suggest me something on the menu?',
    vietnamese:'Bạn có thể gợi ý cho tôi một cái gì đó trên menu?',
    user_message:''
  }, 

]

export const trans_13_2=[
  {
    id:1,
    english:'I will have a speech on tomorrow morning',
    vietnamese:'Tôi có một bài phát biểu vào sáng ngày mai',
    user_message:''
  },
  {
    id:2,
    english:'My foreigner partner comes from Korea',
    vietnamese:'Đối tác nước ngoài của tôi đến từ Hàn Quốc',
    user_message:''
  },
  {
    id:3,
    english:'Where is your house? I live in Thanh Xuan',
    vietnamese:'Nhà bạn ở đâu? Nhà tôi ở quận Thanh Xuân',
    user_message:''
  },
  {
    id:4,
    english:'Can you pass me something? Of course',
    vietnamese:'Bạn có thể chuyển cho tôi vài thứ được không? Tất nhiên rồi',
    user_message:''
  }, 
  {
    id:5,
    english:'Where is your projector? It in the meeting room',
    vietnamese:'Máy chiếu của bạn ở đâu? Nó ở trong phòng họp',
    user_message:''
  },  

]